import { UserRolesReadableText } from '@/presentation/pages/settings/settings-types';
export const makeSelectRoles = (roles) => {
    return (roles === null || roles === void 0 ? void 0 : roles.map(role => {
        return {
            label: UserRolesReadableText === null || UserRolesReadableText === void 0 ? void 0 : UserRolesReadableText[role === null || role === void 0 ? void 0 : role.roleName],
            value: String(role.roleID),
        };
    })) || [];
};
